import React from "react";

/**
 * Signature BARE 1 MERE pink candy-drip transition, placed right before the footer.
 * Full-width, responsive vector graphic (SVG) using the brand pink (#EC1E79) with a
 * glossy highlight and a black candy outline (matching the logo's outlined style).
 */
export function CandyDripDivider() {
  const W = 1440, top = 14, base = 34;
  const drips = [
    { cx: 90, w: 74, d: 72 }, { cx: 285, w: 60, d: 54 }, { cx: 470, w: 92, d: 106 },
    { cx: 650, w: 66, d: 62 }, { cx: 835, w: 80, d: 88 }, { cx: 1015, w: 58, d: 50 },
    { cx: 1190, w: 86, d: 98 }, { cx: 1360, w: 64, d: 66 },
  ].sort((a, b) => b.cx - a.cx);

  let d = `M-10,${top} C240,${top - 6} 520,${top - 6} 760,${top - 1} C1000,${top + 4} 1240,${top - 5} ${W + 10},${top} L${W + 10},${base}`;
  drips.forEach((k) => {
    const xR = k.cx + k.w / 2, xL = k.cx - k.w / 2, mid = base + 0.6 * (k.d - base);
    d += ` L${xR},${base} C${xR},${mid} ${(k.cx + 0.26 * k.w).toFixed(1)},${k.d} ${k.cx},${k.d} C${(k.cx - 0.26 * k.w).toFixed(1)},${k.d} ${xL},${mid} ${xL},${base}`;
  });
  d += ` L-10,${base} Z`;

  const droplets = [{ x: 470, y: 122, r: 6 }, { x: 835, y: 104, r: 5 }, { x: 1190, y: 116, r: 5 }];

  return (
    <div className="pointer-events-none w-full overflow-hidden leading-[0]" aria-hidden="true" data-testid="candy-drip-divider">
      <svg viewBox="0 0 1440 132" width="100%" preserveAspectRatio="xMidYMid meet" className="block h-auto w-full">
        <path d={d} fill="#EC1E79" stroke="#171319" strokeWidth="4.5" strokeLinejoin="round" />
        {droplets.map((o, i) => (
          <ellipse key={i} cx={o.x} cy={o.y} rx={o.r} ry={o.r * 1.4} fill="#EC1E79" stroke="#171319" strokeWidth="3.5" />
        ))}
        <path d={`M26,${top + 3} C360,${top - 2} 760,${top - 2} 1416,${top + 3}`} stroke="#ffffff" strokeOpacity="0.45" strokeWidth="3" fill="none" strokeLinecap="round" />
      </svg>
    </div>
  );
}
